import { CanActivate, GuardResult, MaybeAsync, Router } from '@angular/router';
import { Auth, authState, User } from '@angular/fire/auth';
import { inject, Injectable } from '@angular/core';
import { map, switchMap, take } from 'rxjs/operators';

@Injectable()
export class AllowOnlyAnonymousGuard implements CanActivate {
  afAuth = inject(Auth);
  router = inject(Router);
  authState$ = authState(this.afAuth);
  canActivate(): MaybeAsync<GuardResult> {
    return this.authState$.pipe(
      map((user: User | null) => user?.emailVerified === true),
      take(1),
      switchMap((isAuthenticated: boolean) => {
        if (isAuthenticated === true) {
          return this.router.navigate(['/dashboard']).then(() => false);
        }
        return [true];
      }),
      map((result) => result)
    );
  }
}
